import React from 'react';
import {pageAPI} from "../../../api/page";
import {useAppDispatch, useAppSelector} from "../../../store/hooks";
import {setOptionsAction} from "../../../store/reducers/commonSlice";

const PageSorting = () => {
    const dispatch = useAppDispatch()
    const options = useAppSelector(state => state.common.options)
    const {data: emails} = pageAPI.useGetAllEmailsQuery()

    const changeFilter = (e: React.ChangeEvent<HTMLSelectElement>) => {
        const fieldName = e.target.name
        const fieldValue = e.target.value || ''
        if (!fieldName) return;

        dispatch(setOptionsAction({
            [fieldName]: fieldValue
        }))
    }

    return (
        <div className="flex items-center">
            <span className="mr-3">Filter: </span>
            <select
                name="tracingFilterEmail"
                className="py-1 px-4 border-[1px] outline-none rounded-sm"
                value={options.tracingFilterEmail}
                onChange={changeFilter}
            >
                <option value='' />
                {Array.isArray(emails) && emails.map((email: string, i: number) => <option key={i} value={email}>
                    {email}
                </option>)}
            </select>
        </div>
    );
};

export default PageSorting;